import { ChangeDetectionStrategy, Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { KpoNewsSlideDirective } from "../kpo-news-slide.directive";

@Component({
    selector: "dtm-main-page-lib-news-dialog",
    templateUrl: "./news-dialog.component.html",
    styleUrls: ["./news-dialog.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewsDialogComponent {
    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: KpoNewsSlideDirective | undefined
    ) {}
}
